import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { MobileAuthStore } from "../state/mobile-auth.store";
import { MobileProfileStore } from "../state/mobile-profile.store";
import { resolveMobileElearningQuizRoute } from "./mobile-elearning-quiz-route";

/** `/mobile/elearning/quiz` → surveys participant (E-Satisfaction) ou catalogue (E-Academy). */
export const mobileElearningQuizEntryGuard: CanActivateFn = () => {
  const router = inject(Router);
  const profileStore = inject(MobileProfileStore);
  const authStore = inject(MobileAuthStore);
  const target = resolveMobileElearningQuizRoute(
    authStore.authResult()?.ProfilData ?? null,
    profileStore.activeTenantAppUid(),
    profileStore.activeApplication()?.Code
  );
  return router.parseUrl(target);
};
